import { isJourneyReport } from 'reporting-data/tsTypes/reportTypes';
import JourneyPropertyFilterEditor from 'reporting-enablement/components/reportEditors/JourneyPropertyFilterEditor';
import { SUB_APPS } from 'reporting-data/tsTypes/subAppTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const JourneyPropertyFilterControl = ({
  report,
  updateContext
}) => {
  return /*#__PURE__*/_jsx(JourneyPropertyFilterEditor, {
    report: report,
    onChange: updatedReport => {
      const filtering = updatedReport.getIn(['journeyQuery', 'objectQuery', 'filtering'], null);
      updateContext({
        contactObjectFiltering: filtering
      }, report);
    }
  });
};
JourneyPropertyFilterControl.displayName = 'JourneyPropertyFilterControl';
JourneyPropertyFilterControl.isUsableForReport = ({
  report,
  subAppKey
}) => {
  return isJourneyReport(report) && subAppKey === SUB_APPS.customerJourneyAnalytics;
};
export default JourneyPropertyFilterControl;